import { useState } from 'react'
import { Popover } from '@mui/material'
import { MoreVert } from '@mui/icons-material'

interface ITripleDotPopupWrapper extends React.PropsWithChildren {
  dropdownSectionRenderer?: () => JSX.Element
}

const TripleDotPopupWrapper = ({
  dropdownSectionRenderer
}: ITripleDotPopupWrapper) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const closeDropdown = (): void => {
    setIsDropdownOpen(false)
  }

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  if (dropdownSectionRenderer == null) {
    return null
  }

  return (
    <>
      <button
        className='text-gray-500'
        onClick={(evt) => {
          evt.preventDefault()
          setIsDropdownOpen(!isDropdownOpen)
          setAnchorEl(evt.currentTarget)
        }}
      >
        <MoreVert fontSize='small' />
      </button>
      <Popover
        open={isDropdownOpen}
        onClose={closeDropdown}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: -108 }}
      >
        {dropdownSectionRenderer()}
      </Popover>
    </>
  )
}

export default TripleDotPopupWrapper
